import {createRouter, createWebHistory}  from 'vue-router'

import Index from "./pages/index/Index.vue";
import NotFound from "./pages/not-found/NotFound.vue";
import AuthCallback from "./pages/auth-callback/AuthCallback.vue";
import Dice from "./pages/dice/Dice.vue";
import Mines from "./pages/mines/Mines.vue";
import Coinflip from "./pages/coinflip/Coinflip.vue";
import Slots from "./pages/slots/Slots.vue";
import Live from "./pages/slots/Live.vue";
import SlotsGame from "./pages/slots/Game.vue";
import Faq from "./pages/faq/Faq.vue";
import Revshare from "./pages/referral/Revshare.vue";
import Bonus from "./pages/bonus/Bonus.vue";
import Contacts from "./pages/contacts/Contacts.vue";
import Withdraw from "./pages/withdraw/Withdraw.vue";
import History from "./pages/withdraw/History.vue";
import Terms from "./pages/terms/Terms.vue";
import AmlPolicy from "./pages/policy/AmlPolicy.vue";
import KycPolicy from "./pages/policy/KycPolicy.vue";
import ResponsibleGambling from "./pages/policy/ResponsibleGambling.vue";
import Rang from "./pages/rang/Rang.vue";
import Partnership from "./pages/partnership/Partnership.vue";
import Transfer from "./pages/transfer/Index.vue";
import Loan from "./pages/loan/Index.vue";
import Leaderboard from "./pages/leaderboard/Index.vue";
import Settings from "./pages/settings/Settings.vue";
import Redirect from "./pages/slots/Redirect.vue";

export default createRouter({
    scrollBehavior,
    history: createWebHistory(),
    mode: 'history',
    routes: [
        {
            path: '/settings',
            name: 'settings',
            component: Settings
        },
        {
            path: '/leaderboard',
            name: 'leaderboard',
            component: Leaderboard
        },
        {
            path: '/loan',
            name: 'loan',
            component: Loan
        },
        {
            path: '/transfer',
            name: 'transfer',
            component: Transfer
        },
        {
            path: '/promocodes',
            name: 'promocodes',
            component: Partnership
        },
        {
            path: '/aml-policy',
            name: 'AmlPolicy',
            component: AmlPolicy
        },
        {
            path: '/kyc-policy',
            name: 'KycPolicy',
            component: KycPolicy
        },
        {
            path: '/responsible-gambling',
            name: 'ResponsibleGambling',
            component: ResponsibleGambling
        },
        {
            path: '/rang',
            name: 'rang',
            component: Rang
        },
        {
            path: '/',
            name: 'index',
            component: Index
        },
        {
            path: '/history',
            name: 'history',
            component: History
        },
        {
            path: '/auth/callback',
            name: 'auth-callback',
            component: AuthCallback
        },
        {
            path: '/dice',
            name: 'dice',
            component: Dice
        },
        {
            path: '/mines',
            name: 'mines',
            component: Mines
        },
        {
            path: '/coinflip',
            name: 'coinflip',
            component: Coinflip
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: Redirect,
            meta: {
                layout: 'clear'
            }
        },
        {
            path: '/slots',
            name: 'slots',
            component: Slots
        },
        {
            path: '/play/game/:gameId',
            name: 'slotsGame',
            component: SlotsGame
        },
        {
            path: '/live',
            name: 'live',
            component: Live
        },
        {
            path: '/revshare',
            name: 'revshare',
            component: Revshare
        },
        {
            path: '/bonus',
            name: 'bonus',
            component: Bonus
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq
        },
        {
            path: '/contacts',
            name: 'contacts',
            component: Contacts
        },
        {
            path: '/withdraw',
            name: 'withdraw',
            component: Withdraw
        },
        {
            path: '/terms',
            name: 'terms',
            component: Terms
        },
        {
            path: '/:catchAll(.*)',
            name: 'not-found',
            component: NotFound
        }
    ]
});

function scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
  
    if (to.hash) {
      return { selector: to.hash }
    }
  
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 0 })
      }, 190)
    })
}
